import PropTypes from 'prop-types';

export const PolicyHolderPropTypes = PropTypes.shape({
  title: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  dateOfBirth: PropTypes.string,
  street: PropTypes.string,
  suburb: PropTypes.string,
  postcode: PropTypes.string,
  email: PropTypes.string,
  phoneHome: PropTypes.string,
  phoneMobile: PropTypes.string
});

export const BankingInfoPropTypes = PropTypes.shape({
  paymentFrequency: PropTypes.string,
  paymentMethod: PropTypes.string,
  psbNumber: PropTypes.string,
  bank: PropTypes.string,
  accountNumber: PropTypes.string,
  accountHolderName: PropTypes.string,
  cardType: PropTypes.string,
  cardOwnerName: PropTypes.string,
  cardNumber: PropTypes.string,
  cardExpiryDate: PropTypes.string
});

export const ReimbursementInfoPropTypes = PropTypes.shape({
  paymentMethod: PropTypes.string,
  bsbNumber: PropTypes.string,
  bank: PropTypes.string,
  accountNumber: PropTypes.string,
  accountHolderName: PropTypes.string
});

export const PolicyDetailsPropTypes = PropTypes.shape({
  PolicyNo: PropTypes.string,
  PetGender: PropTypes.oneOf(['Female', 'Male']),
  LevelOfCover: PropTypes.string,
  BenefitPercentage: PropTypes.string,
  PolicyStartDate: PropTypes.string,
  PolicyEndDate: PropTypes.string,
  Excess: PropTypes.number,
  PaymentFrequency: PropTypes.string,
  PremiumFrequency: PropTypes.string,
  Premium: PropTypes.number,
  NextPaymentDate: PropTypes.string,
  PolicyHolder: PolicyHolderPropTypes,
  BankingInfo: BankingInfoPropTypes,
  ReimbursementInfo: ReimbursementInfoPropTypes,
  PlanNumber: PropTypes.string,
  OptionalCovers: PropTypes.string,
  NextCollectionAmount: PropTypes.number,
  Underwriter: PropTypes.string
});

export const PetDetailsPropTypes = {
  PolicyNumber: PropTypes.string,
  OnlineNumber: PropTypes.string,
  FullPolicyNumber: PropTypes.string,
  PartnerNumber: PropTypes.string,
  Name: PropTypes.string,
  Breed: PropTypes.string,
  Species: PropTypes.oneOf(['Canine', 'Feline']),
  Underwriter: PropTypes.string,
  DateOfBirth: PropTypes.string,
  PetProfilePicture: PropTypes.string,
  PetBackGroundImage: PropTypes.string
};

export const BasicPetDetailsPropTypes = PropTypes.shape({
  CustomerName: PropTypes.string,
  PetInfo: PropTypes.arrayOf(PropTypes.shape(PetDetailsPropTypes))
});

export const PetDetailsWithPolicyDetailPropTypes = {
  ...PetDetailsPropTypes,
  PolicyDetails: PolicyDetailsPropTypes,
  PolicyDocuments: PropTypes.arrayOf(PropTypes.string)
};

export const FullPetDetailsPropTypes = PropTypes.shape(PetDetailsWithPolicyDetailPropTypes);

export const ContactDetailsPropTypes = PropTypes.shape({
  phoneMobile: PropTypes.string,
  phoneHome: PropTypes.string,
  phoneWork: PropTypes.string,
  policyNumber: PropTypes.string
});

export const SelectedPet = PropTypes.shape({
  name: PropTypes.string,
  policyNumber: PropTypes.string,
  selected: PropTypes.bool
});
